export function priceDecimals(
  value: string | number,
  withRound = true,
  radix = 10,
): number {
  const valueString = value.toString();
  const [, decimals] = valueString.split(".");

  if (withRound) {
    const decimalsNum = Number.parseInt(decimals, radix);

    return decimalsNum > 0 ? decimals.length : 0;
  }

  return decimals ? decimals.length : 0;
}
